import { observer } from 'mobx-react';
import * as React from 'react';
import styled from '../../styled-components';
import { OpenAPIExternalDocumentation } from '../../types';

const LinkWrap = styled.div<{ compact?: boolean }>`
    a {
        text-decoration: ${(props) => props.theme.typography.links.textDecoration};
        color: ${(props) => props.theme.typography.links.color};

        &:visited {
            color: ${(props) => props.theme.typography.links.visited};
        }

        &:hover {
            color: ${(props) => props.theme.typography.links.hover};
            text-decoration: ${(props) => props.theme.typography.links.hoverTextDecoration};
        }
    }
    ${({ compact }) => (!compact ? 'margin: 1em 0' : '')}
`;

@observer
export class ExternalDocumentation extends React.Component<{
    externalDocs: OpenAPIExternalDocumentation;
    compact?: boolean;
}> {
    render() {
        const { externalDocs } = this.props;
        if (!externalDocs || !externalDocs.url) {
            return null;
        }

        return (
            <LinkWrap compact={this.props.compact}>
                <a href={externalDocs.url}>{externalDocs.description || externalDocs.url}</a>
            </LinkWrap>
        );
    }
}
